export const ActionTypes = {
  FETCH_ALL: 'services/crews/fetch_all',
  FETCH_IS_CREW_NAME_EXISTS: 'services/crews/fetch_is_crew_name_exists',
  SET_IS_CREW_NAME_EXISTS: 'services/crews/set_is_crew_name_exists',
  SET_LOADER_STATUS: 'services/crews/set_loader_status',
  SET_ALL: 'services/crews/set_all',
  UPDATE_CREW: 'services/crews/update_crew',
  DELETE_CREW: 'services/crews/delete_crew',
  ADD_CREW: 'services/crews/add_crew',
  FETCH_CREW_ROTA_DATA_BY_FACTORY: 'services/crews/fetch_crew_rota_by_factory',
  SET_CREW_ROTA: 'services/crews/set_crew_rota',
  IMPORT_EXCEL_CREW_ROTA: 'services/crews/import_excel_crew_rota',
  SET_CREW_ROTA_FILTERS: 'services/crews/set_crew_rota_filters',
  SET_UPLOAD_RESPONSE: 'services/crews/set_upload_response',
};

const fetchAll = ({ crewParams }) => ({
  crewParams,
  type: ActionTypes.FETCH_ALL,
});
const addCrew = ({ crewParams, crew }) => ({
  crew,
  crewParams,
  type: ActionTypes.ADD_CREW,
});
const updateCrew = ({ crewParams, crew }) => ({
  crew,
  crewParams,
  type: ActionTypes.UPDATE_CREW,
});

const isCrewNameExists = ({ name, factoryId, id }) => ({
  id,
  name,
  factoryId,
  type: ActionTypes.FETCH_IS_CREW_NAME_EXISTS,
});
const setIsCrewNameExists = ({ isCrewExists }) => ({
  isCrewExists,
  type: ActionTypes.SET_IS_CREW_NAME_EXISTS,
});
const deleteCrew = ({ id, crewParams }) => ({
  id,
  crewParams,
  type: ActionTypes.DELETE_CREW,
});
const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allCrews }) => ({
  allCrews,
  type: ActionTypes.SET_ALL,
});
const fetchCrewRotaByFactory = ({ filters }) => ({
  filters,
  type: ActionTypes.FETCH_CREW_ROTA_DATA_BY_FACTORY,
});
const setCrewRota = ({ crewRotaData }) => ({
  crewRotaData,
  type: ActionTypes.SET_CREW_ROTA,
});
const setCrewRotaFilters = ({ filters }) => ({
  filters,
  type: ActionTypes.SET_CREW_ROTA_FILTERS,
});
const importExcelRotaFile = ({ importFileParams, filters }) => ({
  filters,
  importFileParams,
  type: ActionTypes.IMPORT_EXCEL_CREW_ROTA,
});
const setUploadResponse = ({ uploadResponse }) => ({
  uploadResponse,
  type: ActionTypes.SET_UPLOAD_RESPONSE,
});

export default {
  fetchAll,
  addCrew,
  updateCrew,
  deleteCrew,
  isCrewNameExists,
  setIsCrewNameExists,
  setLoader,
  setAll,
  fetchCrewRotaByFactory,
  setCrewRota,
  setCrewRotaFilters,
  importExcelRotaFile,
  setUploadResponse,
};
